import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import { registerServiceWorker } from './lib/pwa'
import { installErrorReporter } from './lib/errorReporter'
import { installStaleDeployGuard } from './lib/staleDeploy'
import { initTheme } from './stores/theme.store'
import './i18n'
import './index.css'

initTheme()
installErrorReporter()
installStaleDeployGuard()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        if (error?.response?.status === 429 || error?.response?.status === 401) return false
        return failureCount < 1
      },
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    },
  },
})

registerServiceWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {/* I flag `future` v7_* non esistono piu' dalla v7: quei comportamenti sono
            diventati il default, ed e' esattamente il motivo per cui li avevamo attivati
            in anticipo. Toglierli non cambia il comportamento dell'applicazione. */}
        <BrowserRouter>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: { fontFamily: 'Inter, sans-serif', fontSize: '14px' },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
    </HelmetProvider>
  </StrictMode>
)
